import { render, staticRenderFns } from "./online.vue?vue&type=template&id=fa27bedc&scoped=true&"
import script from "./online.vue?vue&type=script&lang=js&"
export * from "./online.vue?vue&type=script&lang=js&"
import style0 from "./online.vue?vue&type=style&index=0&id=fa27bedc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa27bedc",
  null
  
)

export default component.exports